<template>
  <div class="partner-card">
    <div class="partner-card__image">
      <a v-if="link" :href="link" target="_blank">
        <img :src="image" />
      </a>
      <img v-else :src="image" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'PartnerCard',
  props: {
    link: String,
    image: String,
  },
}
</script>

<style lang="scss" scoped>
  @import "./PartnerCard";
</style>
